import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "@/lib/handlebar";

import 'sonner/dist/styles.css'
import "./styles/globals.css";
import "./styles/simple-invoice.css"
import "./styles/ag-grid.css"
// import "./styles/ag-grid-theme.css";
import { ThemeProvider, Toaster as ToasterShadcn } from "shadcn-ui";
import { Toaster as ToasterSonner } from "sonner";
import reportWebVitals from "./reportWebVitals.ts";
import { RouterWithAuth } from "@/components/RouterWithAuth";
import "@/lib/dayjs";
import "@/lib/ag-grid";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://5e14e96337e654528b8e038b6f48f314@o4509422160052224.ingest.us.sentry.io/4509847451533312",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

// Render the app
const rootElement = document.getElementById("app");

if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <ThemeProvider
        attribute="class"
        defaultTheme="white"
        enableSystem
        disableTransitionOnChange
      >
        <RouterWithAuth />
        <ToasterShadcn />
        <ToasterSonner />
      </ThemeProvider>
    </StrictMode>,
  );
}

// declare module "@tanstack/react-router" {
// 	interface Register {
// 		router: typeof router;
// 	}
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();